import React, { Component } from "react";
import { func, string } from "prop-types";
import Col from "../../../../common/grid/Col.js";
import Input from "../../../../common/input/Input.js";
import AttachmentUploader from "../../../../common/attachment/AttachmentUploader.js";

class PhotosBlock extends Component {
  static propTypes = {
    photos_text: string,
    onChange: func
  };

  render() {
    return (
      <Col _bottom-16>
        <div>
          <label htmlFor="photos" className="key">
            photos: {this.props.isOptional && <span style={{fontSize: '12px', fontStyle: 'italic', marginLefth: '5px'}}>(Optional)</span>}
          </label>
          <Input
            name="photos_text"
            value={this.props.photos_text}
            onChange={this.props.onChange}
            ph="Photos"
          />
        </div>

        <AttachmentUploader
          name="photos_attachment"
          text="No attachments for photos"
          typeId="7"
        />
      </Col>
    );
  }
}

export default PhotosBlock;



// WEBPACK FOOTER //
// ./src/components/main/projects/_form-blocks/PhotosBlock.js